import React from 'react';
import { useAuth } from 'hooks';
import { NavItem } from 'components/nav';

function AuthNavBar() {
	const { user } = useAuth();

	const isLoggedIn = user.username;
	const name = isLoggedIn ? 'Logout' : 'Login';
	const to = isLoggedIn ? '/auth/logout' : '/auth';

	return <NavItem name={name} to={to} />;
}

export default AuthNavBar;
